import {
  type ApplicationDataType,
  ApplicationListItem,
} from '@/components/contacts/application-list/application-list-item';
import { useRespondGroupJoinApplication } from '@/hooks/groups/use-group-join-applications';

interface Props {
  groupId: number;
  application: ApplicationDataType;
}

export default function GroupJoinApplicationListItem({ groupId, application }: Props) {
  const { mutateAsync, isPending } = useRespondGroupJoinApplication(groupId, application);

  return (
    <ApplicationListItem
      application={application}
      isLoading={isPending}
      onRespond={mutateAsync}
    />
  );
}
